import "./LandingPage.css";
import SideBar from "../../SideBar";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function LandingPage({ username, loginFunc, refreshUser }) {
    const navigate = useNavigate();
	return (
		<>
			<Helmet>
				<title>Palette Muse</title>
				<meta name="description" content="Quickly generate art ideas and color palettes. Easily save the ideas you liked for future reference and create some art!" />
				<link rel="canonical" href="https://palettemuse.org/" />

				<script type="application/ld+json">
					{JSON.stringify({
					"@context": "https://schema.org",
					"@type": "WebSite",
					"name": "Palette Muse",
					"url": "https://palettemuse.org",
					})}
				</script>
				<script type="application/ld+json">
				{JSON.stringify({
				"@context": "https://schema.org",
				"@type": "Organization",
				"name": "Palette Muse",
				"url": "https://palettemuse.org",
				"logo": "https://palettemuse.org/logo.png"
				})}
			</script>
			</Helmet>
			<div className="main landing-page">
				<SideBar loggedIn={username != null} loginFunc={loginFunc}></SideBar>
				<div className="landing-page__credits">Made by Adam Krejčí, 2026</div>
				<div className="landing-page__content">
					<section className="landing-page__hero">
						<h1 className="landing-page__title">Welcome to Palette Muse</h1>
						<p className="landing-page__subtitle">
							Challenge yourself to make art based on completely randomly generated art ideas and color palettes.<br/>
							Be creative, think outside of the box and make it work!<br/>
							<b>Spend less time procrastinating and finding inspiration and more time doing art!</b>
						</p>
						<button className="landing-page__cta" type="button" onClick={() => {
							navigate("/generate/palette-idea")
						}}>
							Get Started
						</button>
					</section>

					<section className="landing-page__features">
						<h2 className="landing-page__section-title">Features</h2>
						<div className="landing-page__feature-grid">
							<div className="landing-page__feature-card">
								<h3 className="landing-page__feature-title">Idea + Palette Generator</h3>
								<p className="landing-page__feature-text">
									Roll randomly generated ideas along with a semi-randomly generated four-color palette. <br/>
									<br/>
									You can always regenerate those that do not awaken the creativity within you.
								</p>
							</div>
							<div className="landing-page__feature-card">
								<h3 className="landing-page__feature-title">Save Ideas for later</h3>
								<p className="landing-page__feature-text">
									If you find an idea intriguing, but don't yet have time for it, you can save this idea 
									and/or palette here, to come back for later when the image in your head is complete.
								</p>
							</div>
							<div className="landing-page__feature-card">
								<h3 className="landing-page__feature-title">Find Inspiration</h3>
								<p className="landing-page__feature-text">
									Remember, you do not need to follow every prompt or strict color palette religiously.<br/>
									<br/>
									The ultimate goal is to let it nudge you into the right direction and make something.
								</p>
							</div>
						</div>
					</section>

					<section className="landing-page__about">
						<h2 className="landing-page__section-title">About Palette Muse</h2>
						<p className="landing-page__about-text">
							Palette Muse alows you to challenge yourself and come up with creative artistic solutions
							to randomly generated idea prompts along with a four-color palette (also semi-randomly generated
							with a bit of color harmony).<br/>Use it as a suplemetary tool for inspiration or challenge 
							yourself and try to follow even the wildest combinations you come across.
						</p>
						<p className="landing-page__about-text">
							Please note that this application is still in development and I am but one man with plenty of other
							responsibilities, so you may come across some technical issues or unpolished details.<br/>
							If you wish to support this project financially (Thank you {"<"}3), you can do so here: <br/>
							Now, get to generating and start doing art, ASAP.
						</p>
					</section>
				</div>
			</div>
		</>
	);
}

export default LandingPage;
